import {
    STAFFS_ERROR_ACTION_TYPE,
    STAFFS_FETCH_ACTION_TYPE,
    STAFFS_FETCH_SUCCESS_ACTION_TYPE,
    StaffsAction
} from 'actions/staffs/StaffsActionsTypes';
import { convertToStaff } from 'actions/staffs/StaffsConverter';
import { StaffDto } from 'actions/staffs/StaffsDtos';
import { StaffError } from 'actions/staffs/StaffsError';
import { ApiPublicClient } from 'api/ApiClient';
import { AxiosResponse } from 'axios';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store';
import { RootAction } from 'types/Actions';
import { Staff } from 'types/Staff';

const staffsUrl = '/staff_lookup';

const errorHandler = (error: unknown): StaffsAction => {
    console.error(error);

    return {
        type: STAFFS_ERROR_ACTION_TYPE
    };
};

export const fetchStaffsThunk = (
    marketplaceId: number
): ThunkAction<Promise<Array<Staff>>, RootState, null, RootAction> => {
    return async dispatch => {
        dispatch(fetchStart());

        try {
            const { data: staffsDto }: AxiosResponse<Array<StaffDto>> = await ApiPublicClient.get(
                staffsUrl,
                {
                    params: {
                        marketplace_id: marketplaceId
                    }
                }
            );

            const staffs = staffsDto.map(staff => convertToStaff(staff));

            dispatch(fetchSucces(staffs));

            return staffs;
        } catch (error) {
            dispatch(errorHandler(error));

            throw new StaffError();
        }
    };
};

const fetchStart = (): StaffsAction => {
    return {
        type: STAFFS_FETCH_ACTION_TYPE
    };
};

export const fetchSucces = (staffs: Array<Staff>): StaffsAction => {
    return {
        type: STAFFS_FETCH_SUCCESS_ACTION_TYPE,
        payload: {
            staffs: staffs
        }
    };
};
